import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-image-field',
    templateUrl: './image-field.component.html',
    styleUrls: ['./image-field.component.scss'],
    standalone: false
})
export class ImageFieldComponent implements DynamicField {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  isReadOnly: boolean;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;

  get value(): any {
    return this.imageUrl;
  }
  set value(val: any) {
    this.populateValue(val);
  }
  imageUrl: string;

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  tpOnContentUpdated(): void {
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  populateValue(value: string): void {
    if (!value || value === 'null') {
      this.imageUrl = null;
      return;
    }

    this.imageUrl = value;
  }

  modifyClick(filePath: string): void {
    if (!filePath) {
      return;
    }

    this.value = filePath;
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
